import React from 'react';

/* eslint-disable */
class Vouchers extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}

	componentDidMount() {
        const script = document.createElement("script");
        script.src = '//obee.com.au/common/js/dynamic/iframe.js';
        script.type = 'text/javascript';
        script.async = true;
        document.getElementById('voucher-widget').appendChild(script);
	}

	render() {
		return (
			<div className="main-content-body-inner-container main-content-body-vouchers">
				<div className="main-content-body-title">
					Same Same VOUCHERS
				</div>
				<div style={{ display: 'none' }} />
				<div className="main-content-text-container main-content-body-scrollable-box">
					<div
						id="voucher-widget"
						className="obee-widget"
						data-obee-url="anydaygroup/gift-voucher"
						data-obee-widget-type="gv"
						data-obee-min-height="450"
						data-obee-add-height="50"
						data-obee-scrolltop="true"
					/>
				</div>
			</div>
		);
	}
}

export default Vouchers;



// WEBPACK FOOTER //
// ./src/Theme/Vouchers.jsx